import z from 'zod';
export var SegmentationDashboardWidget;
(function (SegmentationDashboardWidget) {
    SegmentationDashboardWidget["ChartVisualization"] = "chart-visualization";
})(SegmentationDashboardWidget || (SegmentationDashboardWidget = {}));
// Inline content types
export const RichTextContentSchema = z.object({
    type: z.literal('rich-text'),
    data: z.object({
        content: z.record(z.unknown()).optional(),
        title: z.string().optional(),
    }),
});
const InlineContentTypes = z.discriminatedUnion('type', [
    RichTextContentSchema,
]);
export const InlineContentSchema = z.object({
    id: z.string(),
}).and(InlineContentTypes);
// Union type for section content items
export const SectionContentItemSchema = z.union([
    z.object({
        type: z.literal('widget'),
        widgetId: z.number(),
        width: z.number().optional(),
    }),
    z.object({
        type: z.literal('inline'),
        content: InlineContentSchema,
        width: z.number().optional(),
    }),
]);
export const SectionLayoutSchema = z.object({
    id: z.string(),
    title: z.string().optional(),
    tag: z
        .object({
        tagId: z.number(),
        tagName: z.string(),
    })
        .optional(),
    contentItems: z.array(SectionContentItemSchema),
});
export const BlockLayoutSchema = z.object({
    id: z.string(),
    title: z.string().optional(),
    tag: z
        .object({
        tagId: z.number(),
        tagName: z.string(),
    })
        .optional(),
    sections: z.array(z.lazy(() => SectionLayoutSchema)).optional(),
    widgetId: z.number().optional(),
    inlineContent: InlineContentSchema.optional(),
});
export const WidgetGridLayoutSchema = z.object({
    blocks: z.array(BlockLayoutSchema),
});
// Widget Source Metadata Types
export var WidgetSourceType;
(function (WidgetSourceType) {
    WidgetSourceType["QuantAnalysis"] = "quant-analysis";
    WidgetSourceType["BrandInsights"] = "brand-insights";
    WidgetSourceType["Manual"] = "manual";
    WidgetSourceType["Other"] = "other";
})(WidgetSourceType || (WidgetSourceType = {}));
